import React from 'react';
import ThemeToggle from './ThemeToggle';
import SiteLogo from './Logo';

function Header() {
  return (
    <header className='header'>
      <div className='header-container'>
        <div className='logo-title'>
          <SiteLogo />
          <a href='/' style={{ textDecoration: 'none', color: 'inherit' }}>
            <h1>Joel Fernandes</h1>
          </a>
        </div>
        <nav>
          <ThemeToggle />
          <a
            href='https://blog.joel-fernandes.com'
            target='_blank'
            rel='noreferrer'
            className='nav-link'
          >
            Blog
          </a>
          <a
            href='https://github.com/joelfernandes23'
            target='_blank'
            rel='noreferrer'
            className='nav-link'
          >
            GitHub
          </a>
          {process.env.REACT_APP_ENABLE_LINKEDIN === 'true' && (
            <a
              href='https://linkedin.com/in/joelfernandes23'
              target='_blank'
              rel='noreferrer'
              className='nav-link'
            >
              LinkedIn
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
